import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { PrimaryTitleGray } from '../../../../app/theme/tokens/colors';
import { Spinner } from '../../../../shared/ui/Spinners';
import { WideLayout } from '../../../../shared/layout/widelayout';
import { usePortalStore } from '../../../../stores/portalStore';
import { useOrderFlowStore } from '../../store/newOrderFlowStore';
import { SubCategoryCard } from '../../components/new-order/subCategoryCard';
import { ProductDataSource } from '../../../../datasources/catalog/ProductsDataSource';

export const OrderSelectSubCategory = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const currentUser = usePortalStore((state) => state.currentUser);
  const [subCategories, setSubCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const selectedCategory = useOrderFlowStore((state) => state.selectedCategory);
  const navigate = useNavigate();
  const currentPatientBranch = useOrderFlowStore(
    (state) => state.currentPatientBranch
  );

  useEffect(() => {
    if (!selectedCategory?.id) {
      navigate('/order/selectCategory');
      return;
    }

    (async () => {
      setIsLoading(true);
      const products = await new ProductDataSource().QueryProducts(
        null,
        null,
        currentPatientBranch.id,
        selectedCategory.id,
        null,
        null,
        'S',
        null,
        null,
        0,
        1000,
        ['Equipamento', 'Equipamentos', 'Cilindro', 'Cilindros']
      );
      const subCategoryMap = {};
      products.data
        .filter((x) => x.product_subcategory_id > 0)
        .forEach((product) => {
          if (!subCategoryMap[product.product_subcategory_id]) {
            subCategoryMap[product.product_subcategory_id] = {
              id: product.product_subcategory_id,
              description: product.product_subcategory.description,
              produtos: [],
            };
          }
          subCategoryMap[product.product_subcategory_id].produtos.push(product);
        });
      const arr = Object.values(subCategoryMap);
      setSubCategories([...arr]);
      setIsLoading(false);
    })();
  }, [selectedCategory, currentPatientBranch, navigate]);

  return (
    <WideLayout
      outlet={
        <div style={{ padding: '20px 24px' }}>
          <h3
            style={{
              color: PrimaryTitleGray,
              margin: '0 0 20px 0',
              fontSize: '20px',
            }}
          >
            Selecionar subcategoria
          </h3>

          {isLoading ? (
            <div
              style={{
                display: 'flex',
                height: '70vh',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <Spinner />
            </div>
          ) : (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                gap: '20px',
              }}
            >
              {subCategories.map((subcategory, idx) => (
                <SubCategoryCard
                  currentUser={currentUser}
                  subcategory={subcategory}
                  key={idx}
                />
              ))}
            </div>
          )}
        </div>
      }
    />
  );
};
